<template>
  <div>
    <div v-if="userInfo" style="margin: 1%">
      <b-form-group label-align="right" v-for="userAddParam in userInfo.additional_params" v-bind:key="userAddParam.id" label-cols="4" label-cols-xl="2" label-cols-md="4" :label="userAddParam.display_name" >
        <b-form-input v-if="userAddParam.name !='lifestream_id' && userAddParam.display_name != 'Lifestream user id'" :disabled="(userAddParam.name ==='lifestream_email' || userAddParam.display_name==='Lifestream user email') && lifestreamPanelSync" type="text" v-model="userAddParam.value"/>
        <b-input-group-append v-if="userAddParam.name ==='lifestream_email' || userAddParam.display_name==='Lifestream user email'" >
          <b-form-checkbox switch size="md" v-model="lifestreamPanelSync"> {{ $t('From lifestream admin panel sync') }} </b-form-checkbox>
        </b-input-group-append>

        <div v-if="userAddParam.name == 'lifestream_id' || userAddParam.display_name == 'Lifestream user id'">
          <b-row>
            <b-col cols="1">
              <md-button style="margin-top:0rem" class="md-raised" @click="changeLifestreamID(userAddParam.value)" >{{$t('Change')}} </md-button>
            </b-col>
            <b-col>
              <b-form-input :disabled="(userAddParam.name ==='lifestream_email' || userAddParam.display_name==='Lifestream user email') && lifestreamPanelSync" type="text" v-model="userAddParam.value"/>
            </b-col>
          </b-row>
        </div>

      </b-form-group>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    userInfo: null
  },
  data () {
    return {
      lifestreamPanelSync: false
    }
  },
  methods: {
    changeLifestreamID (newVal) {
      let tmp = {
        user_id: this.userInfo.user_id,
        lifestream_id: newVal
      }
      let response = this.$store.dispatch('Users/UPDATE_USER_LIFESTREAM_ID', tmp)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$root.$emit('makeToasts')
        }
      })
    }
  },
  watch: {
    lifestreamPanelSync: function (val) {
      this.$emit('IsLifestreamEmailSync', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/additional/main.vue